














import {Vue, Component, Prop, Watch} from 'vue-property-decorator';
import Directory from '@/model/Directory';
import FileManager from '@/components/FileManager.vue';
import {FileSystemEvents} from '@/events';

@Component({
	name: 'FileSystemBreadcrumb'
})
export default class FileSystemBreadcrumb extends Vue {
	@Prop()
	private currentDirectory: Directory;

	private fileManager: FileManager = null;

	constructor()
	{
		super();

		this.fileManager = this.$parent as FileManager;
	}

	get breadcrumbArray()
	{
		const array = [this.currentDirectory];

		let currentDirectory = this.currentDirectory;

		if (currentDirectory)
		{
			while (currentDirectory.parent)
			{
				array.push(currentDirectory.parent);

				currentDirectory = currentDirectory.parent;
			}

			return array.reverse();
		}
	}

	public openDirectory(directory: Directory)
	{
		this.fileManager.openDirectory(directory);
	}
}
